// This file was automatically generated from appchart.dialog.ordermed.confirmPharmacyNote.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.ordermed.confirmPharmacyNote');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.confirmPharmacyNote.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form id="confirm-pharmacy-note-form"><div class="overlayContainer"><span class="confirm-pharmacy-alert-msg"></span><div class="textareaWrap"><textarea type="text" class="w100" rows="5" name="pharmacyNote"></textarea></div></div></form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.confirmPharmacyNote.alertMsg = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8AppText lgFont">', soy.$$escapeHtml(opt_data.msg), '</p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.confirmPharmacyNote.msg = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8AppText lgFont">', soy.$$escapeHtml(opt_data.msg), '</p>');
  if (!opt_sb) return output.toString();
};
